'use strict'
import {Forms} from './Forms'

class FormsOrder extends Forms {
    static callback(xmlHttp) {
        if (xmlHttp.response.STATUS === 'ERROR') {
            if (xmlHttp.response.CODES === 'basket is empty') {
                location.href = BX.message('SITE_DIR') + 'basket/'
            }
            $('.errorcostum').html(xmlHttp.response.HTML)
            $.each(xmlHttp.response.CODES, function (i, v) {
                $('[name="' + v + '"]').parent().append('<div class="input-items-error">This field is required.</div>')
                $(button).prop("disabled", false)
                $(button).removeClass("loading")
            })
        } else {
            location.href = BX.message('SITE_DIR') + 'confirm/?ORDER_ID=' + xmlHttp.response
        }
    }
}
window.TimeCity = window.TimeCity || {};
window.TimeCity.FormsOrder = FormsOrder;